/* Story videos stay on their cover until an explicit click or keyboard action. */
(function () {
  'use strict';
  if (window.bfStoryVideoLoaded) return;
  window.bfStoryVideoLoaded = true;
  var instances = new WeakMap();
  function init(scope) {
    scope.querySelectorAll('.bf-story--formal [data-bf-story-video]').forEach(function (root) {
      if (root.dataset.bfStoryVideoReady) return;
      var video = root.querySelector('video'), button = root.querySelector('[data-bf-story-play]');
      if (!video || !button) return;
      root.dataset.bfStoryVideoReady = 'true';
      var destroyed = false, listeners = [];
      function listen(target, name, handler) {
        target.addEventListener(name, handler);
        listeners.push([target, name, handler]);
      }
      function setPlaying(playing) {
        root.classList.toggle('is-playing', playing);
        button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
      function toggle() {
        if (!video.paused) { video.pause(); setPlaying(false); return; }
        video.muted = false;
        video.removeAttribute('muted');
        var playback = video.play();
        if (playback && typeof playback.then === 'function') {
          playback.then(function () {
            if (destroyed || !root.getBoundingClientRect().width) video.pause();
            setPlaying(!video.paused);
          }).catch(function () { setPlaying(!video.paused); });
        } else setPlaying(!video.paused);
      }
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.muted = false;
      video.removeAttribute('muted');
      video.pause();
      setPlaying(false);
      listen(root, 'click', toggle);
      listen(video, 'play', function () { setPlaying(true); });
      listen(video, 'pause', function () { setPlaying(false); });
      listen(video, 'ended', function () { setPlaying(false); });
      listen(window, 'resize', function () { if (!root.getBoundingClientRect().width) video.pause(); });
      listen(document, 'visibilitychange', function () { if (document.hidden) video.pause(); });
      instances.set(root, function () {
        destroyed = true;
        listeners.forEach(function (entry) { entry[0].removeEventListener(entry[1], entry[2]); });
        video.pause();
        delete root.dataset.bfStoryVideoReady;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-bf-story-video]').forEach(function (root) {
      var destroy = instances.get(root);
      if (destroy) destroy();
      instances.delete(root);
    });
  });
})();
